import { Injectable } from '@angular/core';

import { Auth, getAuth, onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail, sendEmailVerification, updateEmail, updatePassword, updateProfile } from '@angular/fire/auth';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter, getDocsFromServer, startAt, endAt, getDoc } from '@angular/fire/firestore';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { User as CoddyUser } from '../classes/index';

import { environment } from '../../environments/environment';

import { map } from 'rxjs/operators';

@Injectable()
export class UserService {

	users = [];

	constructor(private http: HttpClient,
		public afAuth: Auth,
		private firestore: Firestore) {

		console.log('in UserService');
		console.log('UserService initialization...');

		this.listUsers()
		.subscribe(users => {
			this.users = users.sort((a, b) => {
				if (a.displayName.toUpperCase() > b.displayName.toUpperCase()) return 1;
				if (a.displayName.toUpperCase() < b.displayName.toUpperCase()) return -1;
				return 0;
			})
		})
	}

	listUsers(){
		return collectionData(query(collection(this.firestore, 'users'), where('type', '==', 'APP_USER')), { idField: 'id' })
		.pipe(map(users => {
			return users.map(user => {
				let object = new CoddyUser();
				object.fromJSON(user);
				return object;
			});
		}));
	}

	findUser(email){
		return collectionData(query(collection(this.firestore, 'users'), where('email', '==', email)), { idField: 'id' })
		.pipe(map(users => {
			return users.map(user => {
				let object = new CoddyUser();
				object.fromJSON(user);
				return object;
			});
		}));
	}

	getUser(userUid){
        return docData(doc(this.firestore, `users/${userUid}`));
	}

	createUser(user) {
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');

		return this.http.post(environment.backendUrl+'createUser', user, {headers: headers});		
	}

	/*addUser(user, password) {
		return Observable.create((observer) => {

			this.afAuth
			.auth
			.createUserWithEmailAndPassword(user.email, password)
			.then(value => {
				console.log('Firebase user successfully created:'+JSON.stringify(value));
				//this.usersCollection.add({ ...user })
				user.uid = value.user.uid;
				let data = {
					email:user.email, 
					displayName:user.displayName, 
					description:user.description, 
					type:user.type,
					role:user.role,
					creationDate:user.creationDate,
					lastUpdateDate:user.lastUpdateDate
				};
				this.afs.doc(`users/${value.user.uid}`)
      			.set(data)
				.then(res => {
					console.log('User successfully created:'+JSON.stringify(res));
					observer.next(res);
				})
				.catch(err => {
					console.log('Something went wrong:',err.message);
					throw Observable.throw('Error creating coddy user:'+err);
				});
			})
			.catch(err => {
				console.log('Something went wrong creating firebase user:',err.message);
				throw Observable.throw('Error creating firebase user:'+err);
			}); 
		});
	}*/

	updateUser(userUid, data){
		return updateDoc(doc(this.firestore, `users/${userUid}`), data);
	}

	updateUserPassword(userUid, password){
		//return this.afs.doc(`users/${userUid}`).update(data);
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');

		let data = {password:password}

		return this.http.post(environment.backendUrl+'updateUser?userUid='+userUid, data, {headers: headers});
	}

	deleteUser(userUid) {
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');

		console.log('Delete user:'+userUid);
		return this.http.post(environment.backendUrl+'deleteUser', {uid:userUid}, {headers: headers});		
	}

	async deleteUserAccount(user){
		await setDoc(doc(this.firestore, `account_deletion_requests/${user.uid}`), {
            email: user.email,
            time: new Date().getTime(),
            optout: true,
            deleteTakenPictures: true
        })
	}

	/*updateUserData(user) {
		// Sets user data to firestore on login
	
		const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
	
		const data = {
		  uid: user.uid,
		  email: user.email,
		  displayName: user.displayName,
		  photoURL: user.photoURL
		}
	
		return userRef.set(data, { merge: true })
	}*/

}
